import { Lang } from "../context/LanguageContext";

export const uiText = {
  en: {
    nav: {
      contact: "Contact",
      buyNow: "Buy Now",
      backToLibrary: "All Trainings",
    },
    library: {
      eyebrow: "Training Library",
      title: "Our Trainings",
      subtitle: "Explore hands-on and online training programs prepared by expert instructors.",
      viewDetails: "View Details",
    },
    meta: {
      date: "Date",
      location: "Location",
      training: "Training",
      language: "Language",
    },
    buyBox: {
      depositNote: (amount: string) => `Pay in full or reserve your seat with a ${amount} deposit.`,
      discountOff: "off",
      registerBuyNow: "Register / Buy Now",
      askQuestion: "Ask a Question",
    },
    about: {
      eyebrow: "About the Program",
      trainingCenter: "Training Center",
    },
    itinerary: {
      eyebrow: "5-Day Intensive Program",
      title: "Day-by-Day Schedule",
      subtitle: "Each training day runs from 09:00 to 16:00.",
    },
    audience: {
      title: "Who Is It For",
    },
    payment: {
      title: "Payment",
      assuranceTitle: "Payment Assurance",
      assuranceText:
        "Payments are processed securely with 3D Secure via Tami. Your card details are sent directly to the payment provider and are never stored on our servers.",
    },
    faq: {
      title: "Frequently Asked Questions",
    },
    contact: {
      eyebrow: "Get in Touch",
      title: "Contact Us",
      subtitle: "Have a question about this program? Reach out and our team will respond promptly.",
      whatsappCta: "Chat on WhatsApp",
      whatsappMessage:
        "Hello, I would like to get more information about this training program.",
      labels: {
        email: "Email",
        phone: "Phone",
        whatsapp: "WhatsApp",
        address1: "Address 1",
        address2: "Address 2",
      },
    },
    cta: {
      title: "Seats are limited — reserve yours now",
      registerNow: "Register Now",
    },
    footer: {
      contact: "Contact",
      securePayments: "Secure Payments",
      rightsReserved: "All rights reserved.",
    },
    checkout: {
      back: "Back",
      close: "Close",
      title: "Complete Your Registration",
      secureNote: "Secure 3D Secure payment via Tami. Your card details are never stored on our servers.",
      sectionPaymentType: "Payment Type",
      depositPaymentLabel: "Pre-registration deposit",
      remainingPaymentLabel: "Remaining balance",
      depositNote: (amount: string) => `Reserve your seat now with a ${amount} deposit and pay the remaining balance later.`,
      remainingNote: "For participants who already paid the pre-registration deposit.",
      sectionContact: "Contact Details",
      sectionBilling: "Billing Address",
      billingTypeIndividual: "Individual",
      billingTypeCorporate: "Corporate",
      companyName: "Company Name",
      taxOffice: "Tax Office",
      taxNumber: "Tax Number",
      sectionCard: "Card Details",
      fullName: "Full Name",
      surname: "Surname",
      email: "Email",
      phone: "Phone",
      identityNumber: "Identity Number (TCKN)",
      address: "Address",
      city: "City",
      district: "District",
      zipCode: "Postal Code",
      cardHolderName: "Cardholder Name",
      cardNumber: "Card Number",
      expireMonth: "MM",
      expireYear: "YY",
      cvv: "CVV",
      installmentCount: "Installments",
      singlePayment: "Single payment",
      installmentsSuffix: "installments",
      submit: "Pay Now",
      processing: "Processing…",
      genericError: "Something went wrong. Please check your details and try again.",
      requiredField: "This field is required.",
      loading3ds: "Loading secure verification…",
    },
    paymentResult: {
      successTitle: "Payment successful!",
      successBody: "Your registration has been received. We will contact you shortly with further details.",
      failedTitle: "Payment could not be completed.",
      failedBody: "The payment was declined or the 3D Secure verification failed. Please try again or contact us for help.",
      errorTitle: "Something went wrong.",
      errorBody: "We could not confirm your payment status. Please contact us so we can check your order.",
      dismiss: "Close",
    },
    legal: {
      close: "Close",
      lastUpdated: "Last updated:",
    },
  },
  tr: {
    nav: {
      contact: "İletişim",
      buyNow: "Satın Al",
      backToLibrary: "Tüm Eğitimler",
    },
    library: {
      eyebrow: "Eğitim Kütüphanesi",
      title: "Eğitimlerimiz",
      subtitle: "Alanında uzman eğitmenlerin hazırladığı uygulamalı ve online eğitim programlarını inceleyin.",
      viewDetails: "İncele",
    },
    meta: {
      date: "Tarih",
      location: "Konum",
      training: "Eğitim",
      language: "Dil",
    },
    buyBox: {
      depositNote: (amount: string) => `Tamamını ödeyebilir veya ${amount} ile yerinizi ayırtabilirsiniz.`,
      discountOff: "indirim",
      registerBuyNow: "Kayıt Ol / Satın Al",
      askQuestion: "Soru Sor",
    },
    about: {
      eyebrow: "Program Hakkında",
      trainingCenter: "Eğitim Merkezi",
    },
    itinerary: {
      eyebrow: "5 Günlük Yoğunlaştırılmış Program",
      title: "Günlük Program Akışı",
      subtitle: "Her eğitim günü 09:00 - 16:00 saatleri arasında gerçekleşir.",
    },
    audience: {
      title: "Kimler İçin Uygun",
    },
    payment: {
      title: "Ödeme",
      assuranceTitle: "Güvenli Ödeme",
      assuranceText:
        "Ödemeler Tami altyapısı üzerinden 3D Secure ile güvenli şekilde işlenir. Kart bilgileriniz doğrudan ödeme kuruluşuna iletilir ve sunucularımızda hiçbir şekilde saklanmaz.",
    },
    faq: {
      title: "Sıkça Sorulan Sorular",
    },
    contact: {
      eyebrow: "Bize Ulaşın",
      title: "İletişim",
      subtitle: "Bu program hakkında bir sorunuz mu var? Bize ulaşın, ekibimiz en kısa sürede yanıt versin.",
      whatsappCta: "WhatsApp'tan Yazın",
      whatsappMessage:
        "Merhaba, bu eğitim programı hakkında daha fazla bilgi almak istiyorum.",
      labels: {
        email: "E-posta",
        phone: "Telefon",
        whatsapp: "WhatsApp",
        address1: "Adres 1",
        address2: "Adres 2",
      },
    },
    cta: {
      title: "Kontenjan sınırlıdır — yerinizi hemen ayırtın",
      registerNow: "Şimdi Kayıt Ol",
    },
    footer: {
      contact: "İletişim",
      securePayments: "Güvenli Ödeme",
      rightsReserved: "Tüm hakları saklıdır.",
    },
    checkout: {
      back: "Geri",
      close: "Kapat",
      title: "Kaydınızı Tamamlayın",
      secureNote: "Tami altyapısı ile güvenli 3D Secure ödeme. Kart bilgileriniz sunucularımızda saklanmaz.",
      sectionPaymentType: "Ödeme Türü",
      depositPaymentLabel: "Ön kayıt ücreti",
      remainingPaymentLabel: "Kalan ödeme",
      depositNote: (amount: string) => `${amount} ile yerinizi hemen ayırtın, kalan bakiyeyi daha sonra ödeyin.`,
      remainingNote: "Ön kayıt ücretini daha önce ödemiş katılımcılar içindir.",
      sectionContact: "İletişim Bilgileri",
      sectionBilling: "Fatura Adresi",
      billingTypeIndividual: "Bireysel",
      billingTypeCorporate: "Kurumsal",
      companyName: "Firma Adı",
      taxOffice: "Vergi Dairesi",
      taxNumber: "Vergi Numarası",
      sectionCard: "Kart Bilgileri",
      fullName: "Ad",
      surname: "Soyad",
      email: "E-posta",
      phone: "Telefon",
      identityNumber: "TC Kimlik No",
      address: "Adres",
      city: "Şehir",
      district: "İlçe",
      zipCode: "Posta Kodu",
      cardHolderName: "Kart Üzerindeki İsim",
      cardNumber: "Kart Numarası",
      expireMonth: "AA",
      expireYear: "YY",
      cvv: "CVV",
      installmentCount: "Taksit",
      singlePayment: "Tek çekim",
      installmentsSuffix: "taksit",
      submit: "Ödemeyi Tamamla",
      processing: "İşleniyor…",
      genericError: "Bir sorun oluştu. Lütfen bilgilerinizi kontrol edip tekrar deneyin.",
      requiredField: "Bu alan zorunludur.",
      loading3ds: "Güvenli doğrulama yükleniyor…",
    },
    paymentResult: {
      successTitle: "Ödeme başarılı!",
      successBody: "Kaydınız alındı. Ekibimiz en kısa sürede sizinle iletişime geçecektir.",
      failedTitle: "Ödeme tamamlanamadı.",
      failedBody: "Ödeme reddedildi veya 3D Secure doğrulaması başarısız oldu. Lütfen tekrar deneyin veya bizimle iletişime geçin.",
      errorTitle: "Bir sorun oluştu.",
      errorBody: "Ödeme durumunuzu teyit edemedik. Siparişinizi kontrol edebilmemiz için lütfen bizimle iletişime geçin.",
      dismiss: "Kapat",
    },
    legal: {
      close: "Kapat",
      lastUpdated: "Son güncelleme:",
    },
  },
} as const satisfies Record<Lang, unknown>;

export function useUiText(lang: Lang) {
  return uiText[lang];
}
